import React, {
  useState, useEffect
} from 'react';
import Menu from "../Menu";
import Header from '../Header';
import Footer from '../Footer';
import { Select } from 'antd';
import { Table, Space } from 'antd';
import { Modal } from 'antd';
import { Config } from '../../config/config';
import Spinner from '../../UIComponents/Spinner/Spinner';
import { doGetAuditorList, addAuditor, getloadAuditorSupply,getSelectedAuditor } from './actions/auditorService'
import { useDispatch, useSelector } from "react-redux";
import AuditorEdit from './AuditorEdit'
import AuditorAdd from './AuditorAdd';
import Cookie from "js-cookie";
import { useNavigate } from 'react-router-dom';

const { Option } = Select;

const AuditorsList = () => {
  const auditorList = useSelector(state => state?.auditorList?.AuditorDetails); //original data
  const auditorDetail = useSelector(state =>state?.auditorList?.AuditorSelectedDetail);
  const status = useSelector(state => state?.auditorList);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const config = JSON.parse(Config);
  const apiInterface = config['api1']
  const title = "Auditor";
  const filterParams = ["zone", "state", "projectScopesId", "id", "storeId"]; // zone, state, projectScopesId, auditorId, storeId
  const [searchedItem, setSearchedItem] = useState({
    zone: [],
    state: [],
    projectScopesId: [],
    id: null,
    storeId : null
})
  const [docModalvisible, setDocModalvisible] = useState(false)
  const [mapModalVisible, setMapModalVisible] = useState(false)
  const TableColumns = [
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      onCell: (_, index) => ({
        colSpan: 1,
      }),
      render: (text, record) => (
        <Space size="middle">
          <div className="table-icons">
            <i className="fa fa-pencil blue" onClick={() => _doNavToEditAuditor(record)} aria-hidden="true"></i>
          </div>
        </Space>
      ),
    },
    {
      title: "Auditor Name",
      width:200,
      dataIndex: "auditorName",
      key: "auditorName"
    },
    {
      title: "Mobile Number",
      width:120,
      dataIndex: "mobileNumber1",
      key: "mobileNumber1"
    },
    {
      title: "Email Id",
      width:220,
      dataIndex: "emailAddress1",
      key: "emailAddress1"
    },
    {
      title: "Project Scopes",
      dataIndex: "projectScopes",
      key: "projectScopes"
    },
    {
      title: "Created By",
      width:120,
      dataIndex: "createdBy",
      key: "createdBy"
    },
    {
      title: "Contract Document",
      dataIndex: "ContractDocument",
      key: "ContractDocument",
      render: (text, record) => (
        <Space size="middle">
          <div className="table-file-icon">
            <span onClick={()=>_doOpenDocModal(record)}>
              <i className="fa fa-file-text" aria-hidden="true"></i>
            </span>
          </div>
        </Space>
      ),
    },
    {
      title: "Status",
      dataIndex: "auditorStatus",
      key: "auditorStatus",
      render: (text, record) => (
        <span>{text == 1?"Active":"InActive"}</span>
      ),
    }
  ]
  const [tableData, setTableData] = useState([]);
  const [formattedAuditorDetails, setformattedAuditorDetails] = useState(null);
  useEffect(() => {
    dispatch(doGetAuditorList())
  }, [])
  useEffect(() => {
    let formattedData = formatAuditorDetails();
    setformattedAuditorDetails(formattedData);
  }, [auditorList])
  useEffect(()=> {
    console.log("formatted data",formattedAuditorDetails);
    if(searchedItem.zone.length!=0 || searchedItem.state.length !=0 ||searchedItem.projectScopesId.length!=0 || searchedItem.id || searchedItem.storeId){
      handleSearch();
    }else{
      setTableData(formattedAuditorDetails?.AuditorList)
    }
  }, [formattedAuditorDetails])
  const _doNavToAddAuditor = () => {
    dispatch(addAuditor(true))
    setSearchedItem({
    zone: [],
    state: [],
    projectScopesId: [],
    id: null,
    storeId : null,
    })
    setTableData(formattedAuditorDetails?.AuditorList)
  }
  const _doNavToEditAuditor = (record) => {
    dispatch(getloadAuditorSupply(record.id, record)) 
  }
  const _doOpenDocModal = (record) => {
    setDocModalvisible(true)
    dispatch(getSelectedAuditor(record.id, record))
  }
  const _doCloseDocModal = () => {
    setDocModalvisible(false)
  }
  const _doCloseMapModal = () => {
    setMapModalVisible(false)
  }
  const handleDownload = (contractFileName) =>{
    if(contractFileName)
      window.location.href = `${apiInterface}/downloadfiles?Image_id=${contractFileName}&token_id=${Cookie.get('token')}`
  }
  const handleSearch = () => {
    if(searchedItem.state.length ==0 && searchedItem.projectScopesId.length==0 && searchedItem.zone.length==0 && !searchedItem.id && !searchedItem.storeId ){
      setTableData(formattedAuditorDetails?.AuditorList)
    }
    else {
      let result =  filterRecursively(filterParams[0], 0);
      bfirstRecursionCompleted = false;
      setTableData(result);
    }
  }
  let filteredResult = [];
  let bfirstRecursionCompleted = false;
  let filterStatus = Array(5).fill(0);
  const filterRecursively = (filterParam, index) =>{
  if(index == filterParams.length)
      return filteredResult;
      if(searchedItem[filterParam] != null || ( Array.isArray(searchedItem[filterParam]) && searchedItem[filterParam].length)){
      for (let j = 0; j < formattedAuditorDetails?.AuditorList.length; j++) {
          if(bfirstRecursionCompleted && filteredResult.length){
          filteredResult.map((ele, i)=> {
              if(((!Array.isArray(searchedItem[filterParam]) && !ele[filterParam].includes(searchedItem[filterParam])) || (Array.isArray(searchedItem[filterParam]) && searchedItem[filterParam].length && !ele[filterParam].split(',').some(item => searchedItem[filterParam].includes(item))))){
              //remove if searched item is not present for that particular parameter in already filtered Array.
              filteredResult.splice(i, 1);
              }
          })
          }
          else if(!bfirstRecursionCompleted && ((!Array.isArray(searchedItem[filterParam]) && formattedAuditorDetails?.AuditorList[j][filterParam].includes(searchedItem[filterParam])) || (Array.isArray(searchedItem[filterParam]) && searchedItem[filterParam].length && formattedAuditorDetails?.AuditorList[j][filterParam].split(',').some(item =>   searchedItem[filterParam].includes(item))))){
          filterStatus[index] = 1;
          filteredResult.push(formattedAuditorDetails?.AuditorList[j]);
          }
      }
  }
  if(!bfirstRecursionCompleted || filteredResult.length !=0){
      if(filterStatus[index]) bfirstRecursionCompleted = true; //first iteration after filteredResult is filled 
      return filterRecursively(filterParams[index+1], index+1)
  }
  }
  const formatAuditorDetails = () => {
    //update ids of project scopes,zone & state as string.
    return {
      ...auditorList,
      AuditorList: auditorList?.AuditorList?.map((auditorList)=> {
        let zoneArray= [];
        let stateArray = [];
        let temp = auditorList?.auditorSupplyDetails.map((auditorSupplyDetails)=> {
          zoneArray.push(auditorSupplyDetails.zone)
          stateArray.push(auditorSupplyDetails.state);
          return auditorSupplyDetails;
        })
        return {
          ...auditorList,
          zone: zoneArray.join(','),
          state: stateArray.join(','),
          id: auditorList?.id.toString(),
          storeId: auditorList?.storeId == null? "" : auditorList?.storeId
        }
      }),
      StateList: auditorList?.StateList.map((state)=> {
        return {
          ...state,
          codeId: state?.codeId.toString()
        }
      }),
      ZoneList: auditorList?.ZoneList.map((zone)=> {
        return {
          ...zone,
          codeId: zone?.codeId.toString()
        }
      }),
      ProjectScopes: auditorList?.ProjectScopes.map((scope)=> {
        return {
          ...scope,
          id: scope?.id.toString()
        }
      })
    }
  }
  return (
    <>
      {status?.isAuditorList ? <div>
        <Header title={title} />
        <Menu />
        <Modal
          open={docModalvisible} title="Contract Documents"
          footer={[
            <button type='button' onClick={_doCloseDocModal} className='btn muted-button  deca-btn-orange'>Close</button>
          ]}
          className="docmodal"
        >
          <table className="m-table">
            <thead>
              <tr>
                <th>S.No</th>
                <th style={{width:200}}>Contract Name</th>
                <th style={{width:120}}>Contract Start Date</th>
                <th style={{width:120}}>Contract End Date</th>
                <th>Document</th>
              </tr>
            </thead>
            <tbody>
              {
                auditorDetail?.auditorContractMappingInfos?.map((ele,index)=>(
                  <tr key={index}>
                    <td>{index+1}</td>
                    <td>{ele.contractName}</td>
                    <td>{new Date(ele.contractStartDate).toDateString()}</td>
                    <td>{new Date(ele.contractEndDate).toDateString()}</td>
                    <td style={{cursor:'pointer'}} onClick={()=>handleDownload(ele.contractFileName)}><i className="fa fa-download"></i></td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </Modal>
        <div className='content-wrapper'>
          {status?.loading ? (
            <Spinner />
          ) : (
            <div>
              <div className="m-btn-block">
                <div className="m-btn-block__container">
                  <div className="m-btn-block__icon">
                    <i className="fa fa-plus-circle" aria-hidden="true"></i>
                  </div>
                  <div className="m-btn-block__btns">
                    <button type='submit' onClick={_doNavToAddAuditor} className='btn btn-secondary deca-btn-yellow'>Create New Auditor</button>
                  </div>
                </div>
              </div>
              <div className='content'>
                <div className="m-panel mt-10">
                  <div className="m-panel__body p10">
                    <div className="row">
                    <div className="col-md-2">
                        <div className='form-group'>
                          <label htmlFor='exampleInput'>Auditor Name</label>
                          <Select className="form-control"
                            allowClear={true}
                            showSearch
                            onChange={(value) => {
                              setSearchedItem({...searchedItem,id:value})
                            }}
                            value={searchedItem.auditorName}
                            placeholder="-- Please Select --"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                          >{
                            formattedAuditorDetails?.AuditorNameList?.map(((item) =>
                                <Option key={item.id} value={item.id}>{item.auditorName}</Option>
                              ))
                            }
                          
                          </Select>
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className='form-group select_h150'>
                          <label htmlFor='exampleInput'>Select zone</label>
                          <Select className="form-control"
                            showSearch
                            mode="multiple"
                            placeholder="-- Please Select --"
                            onChange={(value) => {
                              setSearchedItem({...searchedItem,zone:value})
                            }}
                            value={searchedItem.zone}
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                          >{
                              formattedAuditorDetails?.ZoneList?.map((item =>
                                <Option key={item.codeId} value={item.codeId}>{item.codeValue}</Option>
                              ))
                            }
                          </Select>
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className='form-group select_h150'>
                          <label htmlFor='exampleInput'>Select state</label>
                          <div className="">
                            <Select className="form-control"
                              showSearch
                              mode="multiple"
                              onChange={(value) => {
                                setSearchedItem({...searchedItem,state:value})
                              }}
                              placeholder="-- Please Select --"
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                              }
                              value={searchedItem.state}
                            >{
                                formattedAuditorDetails?.StateList?.map((item =>
                                  <Option key={item.codeId} value={item.codeId}>{item.codeValue}</Option>
                                ))
                              }
                            </Select>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className='form-group select_h150'>
                          <label htmlFor='exampleInput'>Select Project Scope</label>
                          <Select className="form-control"
                            showSearch
                            mode="multiple"
                            onChange={(value) => {
                              setSearchedItem({...searchedItem,projectScopesId:value})
                            }}
                            placeholder="-- Please Select --"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            value={searchedItem.projectScope}
                          >{
                              formattedAuditorDetails?.ProjectScopes?.map((item =>
                                <Option key={item.id} value={item.id}>{item.name}</Option>
                              ))
                            }
                          </Select>
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className='form-group'>
                          <label htmlFor='exampleInput'>Store Name</label>
                          <Select className="form-control"
                            showSearch
                            allowClear={true}
                            onChange={(value) => {
                              setSearchedItem({...searchedItem,storeId:value})
                            }}
                            placeholder="-- Please Select --"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            value={searchedItem.storeName}
                          >{
                              formattedAuditorDetails?.StoreList?.map(((item,index) =>
                                <Option key={index} value={item.storeId}>{item.storeName}</Option>
                              ))
                            }
                          </Select>
                        </div>
                      </div>

                      <div className="col-md-1 btn-no-lbl">
                        <button type='submit' className='btn btn-secondary btn-icon deca-btn-yellow' onClick={handleSearch}>
                          <i className="fa fa-search"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="m-panel">
                  <div className="m-panel__body p10">
                    <div className="m-table__main">
                      <div className="m-table__responsive">
                        <Table columns={TableColumns} dataSource={tableData} className="auditor_table"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          )}
        </div>

      </div> : null}
      {
        status?.isAuditorEdit ? <AuditorEdit /> : null
      }
      {
        status?.isAuditorCreate ?
          <AuditorAdd /> : null
      }
      <Footer />
    </>
  )
}

export default AuditorsList;